import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import axios from '../../util/Axios';
import { useEffect, useState } from 'react';
import PatientRow from './PatientRow';

export default function MyPatients() {
  const [patients, setPatients] = useState([]);

  useEffect(() => {
    axios('/users/doctors/patients').then((data) => {
      const patients = data.data;
      patients.sort((p1, p2) => p1.name.localeCompare(p2.name)); //sort by name asc
      setPatients(patients);
    });
  }, []);

  return (
    <>
      <Paper
        sx={{
          minWidth: 650,
          marginTop: 16,
          marginBottom: 16,
          margin: '16px',
        }}
      >
        <Typography
          sx={{
            width: '100%',
            textAlign: 'center',
            marginTop: '16px',
            fontSize: '2em',
          }}
        >
          My Patients
        </Typography>

        <Table sx={{}} aria-label="simple table" size="small">
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Name</TableCell>
              <TableCell>Age</TableCell>
              <TableCell>Sex</TableCell>
              <TableCell>Tests Done</TableCell>
              <TableCell>Medical History</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {patients.map((patient) => (
              <PatientRow key={patient.uuid} patient={patient} />
            ))}
          </TableBody>
        </Table>
      </Paper>
    </>
  );
}
